import { EventEmitter } from "@angular/core";
import { ColumnModel } from "../../../shared/models/column.model";
import { POITypeModel } from "../../../shared/models/poi-type.model";
export class POITypeBuildData{
    module = {
        name: "POI Type",
        new_name: "poitype",
        filtered_name:"POI Type",
        has_dot_menu: true,
        icon:'fa-map-marked-alt',
        permission:'route_poi_type'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:POITypeModel) => {//Generates Row for codeblack-table
        return POITypeModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}